import NeatixLoader from './NeatixLoader';
// import NeatixLoader2 from './NeatixLoader2';
// import SerpLoader from './SerpLoader';

const Loader = ({ loading }) => {
  if (!loading) return null;

  return (
    <>
      <NeatixLoader loading={loading} />

      {/* <SerpLoader loading={loading} /> */}
    </>
  );
};

export default Loader;
